import React, { Component } from 'react';
import { Col, Button, Row, InputGroup,Input,
    InputGroupAddon} from "reactstrap";
import {UserRole} from '../../../utils/constants';
import * as Url from '../../../utils/url';
import axios from '../../../axios';
import {filter} from 'lodash';
import { connect } from 'react-redux';
import OfficeMate from './OfficeMate/OfficeMate';
import Loading from '../../../hoc/Loading/Loading';
import findIndex from 'lodash/findIndex';
import './OfficeMates.css';

class OfficeMates extends Component {
    constructor(props) {
       super(props);
       this.state = {
           officeMates : [],
           searchedTerm:"",
           displayUsers: [],
       }
    }

    componentDidMount() {
        this.getOfficeMates();
    }
    
    // Handle role changed 
    handleRoleChange = (changeRoleOfficeMate) => {
        console.log(changeRoleOfficeMate, "----")
        let officeMates = [...this.state.officeMates];
        officeMates = officeMates.map((officeMate) => {
            if(officeMate._id === changeRoleOfficeMate._id) {
                return {...officeMate, role: changeRoleOfficeMate.role};
            } else {
                return officeMate;
            }
        })
        this.setState({officeMates: officeMates, displayUsers:officeMates});
    }

    // Handle user removed 
    handleUserRemoved = (id) => {
        let officeMates = [...this.state.officeMates];
        const i = findIndex(officeMates, (officeMate) => {return officeMate._id === id});
        if(i > -1) {
            officeMates.splice(i,1);
          }
        this.setState({officeMates: officeMates, displayUsers:officeMates});
    }

    // Get Office Mates
    getOfficeMates = () => {
        axios.get(Url.getOfficeMates).then((response) => {
            console.log(response.data.data )
            this.setState({ officeMates: response.data.data , displayUsers:response.data.data});
        }).catch((error) => {
            console.log(error);
        })
    }

    goToInviteOfficeMates = () => {
        this.props.history.push('/home/office/invite-office-mates');
    }

    handleSearchQueryChanged = ({target}) => {
        let { value } = target;
        console.log(value)
        // this.state.officeMates
        let {officeMates}=this.state
        // value = value.replace(/\s/g,'')
        let list = [];
        // console.log
        if(value.length === 0) {
          list = officeMates;
        } else {
            list= officeMates.filter(user=>{
                let fname = user.firstName ? user.firstName :''
                let lname = user.lastName?user.lastName:''
                let name = fname + ' ' +lname + user.email
                console.log(name)
                if(name.toLowerCase().includes(value.toLowerCase())){
                    return user
                }
            })
        //   list = filter(officeMates,(user) => user.firstName.toLowerCase().includes(value.toLowerCase()) );
        }
       
        
       
        this.setState({
          displayUsers : list,
          searchedTerm : value
        });
    }

    render() {
        let {searchedTerm}=this.state
        return(
            <div>
                <Row className="mt30 mlmr0">
                    <Col sm={6}><span className="officemate-title">
                    <InputGroup  style={{height:'40px'}}>
                        <Input className="toolkit-field tool-search-box" placeholder="Search Officemates" 
                        onChange={this.handleSearchQueryChanged} value={searchedTerm}/>
                        <InputGroupAddon addonType="append">
                        <Button className="color-DADADA border-color-C3C4C7" style={{height:'40px'}}>
                            <i style={{color:'#818389'}} className="flaticon-search"></i>
                        </Button>
                        </InputGroupAddon>
                    </InputGroup>
                    </span></Col>
                
                </Row>
                {/* <Row className="mlmr0 mt10"><Col><div className="officemates-hr-line"></div></Col></Row> */}
                <div className="mt30">
                    {this.state.displayUsers.map((officeMate, index) => {
                        return (
                            <OfficeMate
                                key={officeMate._id}
                                officeMate={officeMate}
                                userRole={this.props.user.role}
                                user={this.props.user}
                                onRoleChange={this.handleRoleChange}
                                onUserRemoved={() => this.handleUserRemoved(officeMate._id)}
                                rowIndex={index}
                                {...this.props}
                            />);
                    })}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
	return {
     user: state.user.profile,
	}
}

export default connect(mapStateToProps)(Loading(OfficeMates,axios));